<template>
<div>
  <div class="card">
    <header class="header-card">
    <p>{{$t('detailOperationDiverse.informationsMouvement.title')}}</p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <b-field class="column is-3"
            :label="$t('detailOperationDiverse.informationsMouvement.tiers')"
            custom-class="has-text-weight-normal is-italic is-marginless">
          <span class="has-text-weight-bold">
            <router-link-blank v-if="isClient"
              :message="operationDiverse.mouvementOd.tiers.nomCommercial"
              :to="{ name: 'c.bodac.clients/contacts-client',
              params: {id: operationDiverse.mouvementOd.tiersId}}">
            </router-link-blank>
            <router-link-blank v-else
              :message="operationDiverse.mouvementOd.tiers.nomCommercial"
              :to="{ name: 'c.baux.bailleur',
              params: {id: operationDiverse.mouvementOd.tiersId}}">
            </router-link-blank>
          </span>
        </b-field>
        <b-field :label="$t('detailOperationDiverse.informationsMouvement.adresse')"
        class="column is-5"
        custom-class="has-text-weight-normal is-italic is-marginless">
          <span class="has-text-weight-bold">
            {{ operationDiverse.mouvementOd.tiers.adressePostale.adresse1 }}
          </span>
        </b-field>
        <b-field :label="$t('detailOperationDiverse.compteComptable')"
        class="column is-4"
        custom-class="has-text-weight-normal is-italic is-marginless">
          <span class="has-text-weight-bold">
            {{ operationDiverse.mouvementOd.tiers.compteComptable }}
          </span>
        </b-field>
        <b-field :label="$t('detailOperationDiverse.informationsMouvement.dateMouvement')"
        class="column is-3"
        custom-class="has-text-weight-normal is-italic is-marginless">
          <span class="has-text-weight-bold">
            {{ operationDiverse.mouvementOd.dateMouvement | formatDate }}
          </span>
        </b-field>
        <b-field :label="$t('detailOperationDiverse.libelle')"
        class="column is-5"
        custom-class="has-text-weight-normal is-italic is-marginless">
          <span class="has-text-weight-bold">
            {{operationDiverse.mouvementOd.libelle}}
          </span>
        </b-field>
        <b-field :label="$t('detailOperationDiverse.informationsMouvement.debit')"
        class="column is-2"
        custom-class="has-text-weight-normal is-italic is-marginless">
          <span class="has-text-weight-bold">
            {{ operationDiverse.mouvementOd.debit | formatDevise}}
          </span>
        </b-field>
        <b-field :label="$t('detailOperationDiverse.informationsMouvement.credit')"
        class="column is-2"
        custom-class="has-text-weight-normal is-italic is-marginless">
          <span class="has-text-weight-bold">
            {{ operationDiverse.mouvementOd.credit | formatDevise}}
          </span>
        </b-field>
        <b-field :label="$t('detailOperationDiverse.journal')"
        class="column is-3"
        custom-class="has-text-weight-normal is-italic is-marginless">
          <span class="has-text-weight-bold">
            {{operationDiverse.journal }}
          </span>
        </b-field>
        <b-field :label="$t('detailOperationDiverse.reference')"
        class="column is-3"
        custom-class="has-text-weight-normal is-italic is-marginless">
          <span class="has-text-weight-bold">
            {{ operationDiverse.reference }}
          </span>
        </b-field>
        <b-field class="column is-5"
            :label="$t('detailOperationDiverse.exportOdComptabilite') "
            custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
            {{ operationDiverse.exportOdComptabilite ? $t('general.oui')
                : $t('general.non') }}
            </span>
        </b-field>
      </div>
    </div>
  </div>
  <div class="card mgt-20px">
    <header class="header-card">
      <p>{{$t('detailOperationDiverse.informationsLigne.title')}}</p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <v-client-table :data="operationDiverse.lignesOd" :columns="columns" :options="options"
                    class="tableWithChildRow column is-12">
          <div slot="credit" slot-scope="props" class="is-pulled-right">
            {{ props.row.credit | formatDevise}}
          </div>
          <div slot="debit" slot-scope="props" class="is-pulled-right">
            {{ props.row.debit | formatDevise}}
          </div>
          <div slot="ligneCompteTva" slot-scope="props" class="is-pulled-right">
            {{ props.row.ligneCompteTva ?  $t('general.oui')
                : $t('general.non') }}
          </div>
          <template slot="afterBody">
            <tfoot>
              <tr>
                <td colspan="4"></td>
                <td class="right">
                  {{ totalDebit | formatDevise }}
                </td>
                <td class="right">
                  {{ totalCredit | formatDevise }}
                </td>
                <td colspan="1"></td>
              </tr>
            </tfoot>
          </template>
        </v-client-table>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import cloneDeep from 'lodash/cloneDeep';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { TIERS_SOUS_TYPE_AUCUN } from '@/configuration/tiers/tiersConf';

export default {
  props: {
    operationDiverse: {
      type: Object,
      required: true,
    },
  },
  components: {
    routerLinkBlank,
  },
  computed: {
    totalCredit() {
      let total = 0;
      total += this.operationDiverse.mouvementOd?.credit || 0;
      total += this.operationDiverse.lignesOd
        .map(f => f.credit)
        .reduce((a, b) => a + b, 0);
      return total;
    },
    totalDebit() {
      let total = 0;
      total += this.operationDiverse.mouvementOd?.debit || 0;
      total += this.operationDiverse.lignesOd
        .map(f => f.debit)
        .reduce((a, b) => a + b, 0);
      return total;
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          compte: this.$t('detailOperationDiverse.compteComptable'),
          compteAuxiliaire: this.$t('detailOperationDiverse.informationsLigne.compteAuxiliaire'),
          libelle: this.$t('detailOperationDiverse.libelle'),
          reference: this.$t('detailOperationDiverse.reference'),
          debit: this.$t('detailOperationDiverse.debit'),
          credit: this.$t('detailOperationDiverse.credit'),
          ligneCompteTva: this.$t('detailOperationDiverse.informationsLigne.ligneCompteTva'),
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: texts,
        columnsClasses: {
          compte: 'colonneMinWidth-150px',
        },
        sortable: ['compte', 'compteAuxiliaire', 'libelle', 'reference', 'debit', 'credit', 'ligneCompteTva'],
      };
    },
    columns() {
      return ['compte', 'compteAuxiliaire', 'libelle', 'reference', 'debit', 'credit', 'ligneCompteTva'];
    },
    isClient() {
      return this.operationDiverse.mouvementOd.tiers.sousTypes.includes(TIERS_SOUS_TYPE_AUCUN);
    },
  },
};
</script>
